import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardActions, Typography, Button, CardHeader, Grid } from '@material-ui/core';
import { genfunction } from 'helpers';
import ReactHtmlParser from 'react-html-parser';

const { TourDisplayAreaDefaultImage } = window['runConfig'];

const useStyles = makeStyles(theme => ({
  root: {},
  card: {
    "&:hover": {
      transform: 'scale(1.02)',
      WebkitTransform: 'scale(1.02)',
      boxShadow: "inset 0 0 0 2px",
      cursor: 'pointer'
    }
  },
  tourheaderbox: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  image: {
    width: "100%",
    objectFit: "cover",
    objectPosition: "center"
  }
}));

const ProductCard = props => {

  const { area } = props;
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardHeader className={classes.tourheaderbox}
        title={area.AreaName}
        titleTypographyProps={{ color: "inherit" }}
      />
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={4} >
            <img alt="DisplayAreaImage" className={classes.image} src={genfunction.replaceEscapeCharacters(area.ImageURL && area.ImageURL != "" ? area.ImageURL : TourDisplayAreaDefaultImage)} />
          </Grid>
          <Grid item xs={12} sm={8}>
            <Typography variant='body1' color="textSecondary">
              {ReactHtmlParser(genfunction.replaceEscapeCharacters(area.DisplayText))}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>
        <Grid container >
          <Grid item xs={12} sm={4}>
            <Button fullWidth={true} variant="contained" onClick={() => props.callCalender(area)} color="primary">Buy Now</Button>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default ProductCard;